// dashboard-frontend/src/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './App.css';  /* Optional: your additional global styles */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
